import { put } from "redux-saga/effects";
import http from "axios/index";
import saveAs from "react-file-download";
import i18n from "../../../utils/i18n";

import { GET_REPORTS, REPORT_PDF_DOWNLAOD } from "../../../api/constants";

import {
  getReportingRequestSuccessful,
  getReportingRequestFailure,
} from "../../actions";

import {
  SWAL_ERROR_TITLE,
  SWAL_TYPE_ERROR,
  DOWNLOADING_TITLE,
  PDF_DOWNLOADING_MESSAGE,
  PDF_FILE_NAME,
  UNKNOWN_ERROR_MESSAGE,
} from "../../../utils/constants";

import { swalOpen, swalClose } from "../../utils";

export function* getReportingRequest({ payload }) {
  try {
    const {
      accessToken,
      employeeId,
      month,
      year,
      isMultiDate,
      startDate,
      endDate,
      costStatus,
    } = payload;
    let body = new URLSearchParams();
    body.append("accessToken", accessToken);
    body.append("employeeId", employeeId);
    body.append("month", month);
    body.append("year", year);
    body.append("isMultiDate", isMultiDate);
    body.append("startDate", startDate);
    body.append("endDate", endDate);
    body.append("costStatus", costStatus);
    const response = yield http.post(GET_REPORTS, body);

    if (!response.data.err) {
      yield put(
        getReportingRequestSuccessful({
          data: response.data.data.costs,
          loading: false,
        })
      );
    } else if (response.data.err && !response.data.data) {
      swalOpen(
        SWAL_ERROR_TITLE,
        "İstek Zaman Aşımına Uğradı.Lütfen daha kısa aralıkta rapor çekmeyi deneyiniz!",
        SWAL_TYPE_ERROR,
        false
      );
      yield put(getReportingRequestFailure({ loading: false }));
    } else {
      swalOpen(SWAL_ERROR_TITLE, response.data.data, SWAL_TYPE_ERROR, false);
    }
  } catch (error) {
    //yield put(getReportingRequestFailure(error));
    console.error("Error happened when try to fetch supported locales.");
  }
}

export function* pdfDownloadReport({ payload }) {
  try {
    const { employeeInfo, costIds, accessToken } = payload;
    const {
      employeeOID,
      employeeID,
      employmentID,
      employeeName,
      pdfLanguage,
      unitID,
      unitLogo,
      unitName,
    } = employeeInfo;
    let body = new URLSearchParams();
    body.append("employeeOID", employeeOID);
    body.append("employeeID", employeeID);
    body.append("employmentID", employmentID);
    body.append("employeeName", employeeName);
    body.append("pdfLanguage", pdfLanguage);
    body.append("unitID", unitID);
    body.append("unitLogo", unitLogo);
    body.append("unitName", unitName);
    body.append("accessToken", accessToken);
    body.append("costIds", costIds);
    swalOpen(DOWNLOADING_TITLE, PDF_DOWNLOADING_MESSAGE, null, true);
    const response = yield http.post(REPORT_PDF_DOWNLAOD, body, {
      responseType: "arraybuffer",
    });
    swalClose();
    yield saveAs(response.data, employeeName + i18n.t("PDF_FILE_NAME"));
  } catch (error) {
    swalOpen(SWAL_ERROR_TITLE, UNKNOWN_ERROR_MESSAGE, SWAL_TYPE_ERROR, false);
    console.error("Error happened when try to download PDF.Error : ", error);
  }
}
